module.exports = __webpack_public_path__ + "media/audio9.30946eca.mp3";